import { ChangeDetectionStrategy,  Component, Inject, input } from "@angular/core";

import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'soft-ktostamm-kunde-subnummer-master-view',
    imports: [],
    templateUrl: './ktostamm-kunde-subnummer.master-view.html',
    styleUrls: ['./ktostamm-kunde-subnummer.master-view.css']
})
export class KtostammKundeSubnummerMasterView implements FieldOkItemComponent<any>{
  readonly item = input<any>();
}
